import { useEffect } from 'react';

// Detect if clicking outside of dropdown. To close it
export const detectClickOutside = (ref, callback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (event.target === null) {
        return;
      }
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    }

    // Bind the event listener
    document.addEventListener('click', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
  });
};
